import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { search as getStudentCourseSessionEnrollment } from 'store/attendance/schedule'
import { Box, LinearProgress } from '@mui/material'
import { useMember } from 'components/Providers'
import ScheduleTable from 'components/Schedule'

export const Schedule = () => {
  const dispatch = useDispatch()
  const member = useMember()

  const [studentCourseSessionEnrollment, setStudentCourseSessionEnrollment] = useState()
  const [scheduledSessions, setScheduledSessions] = useState()
  const [unScheduledSessions, setUnscheduledSessions] = useState()
  const [startRenderList, setStartRenderList] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const isLoading = useSelector(state => state.attendance.schedule.loading)

  const courseEnrollmentFromStore = useSelector(state => state.academic.student.detail.courseSessionEnrollment)

  const studentCourseSessionEnrollmentFetch = async () => {
    if (!courseEnrollmentFromStore) {
      const data = await dispatch(
        getStudentCourseSessionEnrollment({
          memberId: member.id,
        }),
      )
      if (data?.payload?.length) {
        setStudentCourseSessionEnrollment(data.payload)
      } else {
        setErrorMessage('There is not any Course Enrollment')
      }
    } else {
      setStudentCourseSessionEnrollment(courseEnrollmentFromStore)
    }
  }

  useEffect(() => {
    studentCourseSessionEnrollmentFetch()
  }, [member?.id])

  useEffect(() => {
    if (studentCourseSessionEnrollment?.length > 0) {
      let temp = []
      const rawScheduledSessions = studentCourseSessionEnrollment?.filter(
        item => item.courseSession?.schedules?.length > 0,
      )
      rawScheduledSessions.forEach(item => {
        item.courseSession.schedules.forEach(scheduleItem => {
          const newItem = {
            id: item.courseSession.id,
            name: item.courseSession.course.name + ' - ' + item.courseSession.name,
            startTime: scheduleItem.period.startTime,
            endTime: scheduleItem.period.endTime,
            dayOfWeek: scheduleItem.day,
            periodId: scheduleItem.period.id,
            room: scheduleItem?.room?.id
              ? scheduleItem?.room
              : item?.courseSession?.room?.id
              ? item?.courseSession?.room
              : null,
          }
          temp = addSessionToSchedule(newItem, temp)
        })
      })
      setScheduledSessions(temp)
      setErrorMessage('')
      setUnscheduledSessions(
        studentCourseSessionEnrollment?.filter(item => item.courseSession?.schedules?.length === 0),
      )

    } else if (studentCourseSessionEnrollment?.length === 0) {
      setErrorMessage('There is not any Course Enrollment')
    }
  }, [studentCourseSessionEnrollment])

  const addSessionToSchedule = (newItem, storage) => {
    if (storage.length === 0) {
      storage.push({
        startTime: newItem.startTime,
        endTime: newItem.endTime,
        dayOfWeek: newItem.dayOfWeek,
        periodId: newItem.periodId,
        list: [{ id: newItem.id, name: newItem.name, room: newItem.room }],
      })
      return storage
    }
    let existsIndex = -1
    storage.forEach((item, index) => {
      if (
        item.startTime === newItem.startTime &&
        item.endTime === newItem.endTime &&
        item.dayOfWeek === newItem.dayOfWeek &&
        item.periodId === newItem.periodId
      ) {
        if (existsIndex === -1) existsIndex = index
      }
    })

    if (existsIndex === -1) {
      storage.push({
        startTime: newItem.startTime,
        endTime: newItem.endTime,
        dayOfWeek: newItem.dayOfWeek,
        periodId: newItem.periodId,
        list: [{ id: newItem.id, name: newItem.name, room: newItem.room }],
      })
      return storage
    } else {
      const temp = storage[existsIndex]
      temp.list.push({ id: newItem.id, name: newItem.name, room: newItem.room })
      storage[existsIndex] = temp
      return storage
    }
  }

  useEffect(() => {
    setStartRenderList(true)
  }, [scheduledSessions])

  if (isLoading) return <LinearProgress color="primary" />

  return startRenderList && scheduledSessions && !errorMessage ? (
    <ScheduleTable
      unScheduledSessions={unScheduledSessions}
      scheduledSessions={scheduledSessions}
    />
  ) : errorMessage ? (
    <Box sx={{ m: 4 }}>{errorMessage}</Box>
  ) : (
    startRenderList === false && <LinearProgress sx={{ m: 2 }} color="success" />
  )
}
